<app-header></app-header>

<section class="container mt-5 pt-0 pt-lg-5 mb-5">
  <div class="et_pb_text_inner">
    <h5 class="text-center">
      Effective March 1, 2026, our service charge prices will be changing.
      Please note, all services initiated prior to this date will maintain the
      pricing that was in effect at the time of the request.
    </h5>
    <br />
    <h1 class="services-heading mb-0">Service Charges</h1>
    <br />
    <table>
      <thead>
        <tr>
          <th scope="col">Service Charge</th>
          <th scope="col">Description</th>
          <th class="empty-row" scope="col" style="width: 49px">&nbsp;</th>
          <th scope="col" class="pricing">
            <strong>&nbsp;Pricing&nbsp;</strong>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td data-label="Service Charge">Paper Statement Fee</td>
          <td data-label="Description">
            Associated charge with distributing a paper invoice statement
          </td>
          <td class="empty-row">&nbsp;</td>
          <td data-label="Pricing">&nbsp;$3</td>
        </tr>
        <tr>
          <td data-label="Service Charge">Late Fee</td>
          <td data-label="Description">
            Charge for failing to pay the monthly payment on/before the due
            date. Applicable charge may be less in certain states.
          </td>
          <td class="empty-row">&nbsp;</td>
          <td data-label="Pricing">&nbsp;$25</td>
        </tr>
        <tr>
          <td data-label="Service Charge">
            Home Filing Service Charge
          </td>
          <td>
            Charge for processing a customer’s request for a home sale.
          </td>
          <td class="empty-row">&nbsp;</td>
          <td data-label="Pricing">&nbsp;$400</td>
        </tr>
        <tr>
          <td data-label="Service Charge">
            Home Filing Service Charge (Prepayment)
          </td>
          <td>
            Charge for processing a customer’s request for a prepayment as part of a home sale.
          </td>
          <td class="empty-row">&nbsp;</td>
          <td data-label="Pricing">&nbsp;$400</td>
        </tr>
        <tr>
          <td data-label="Service Charge">
            Refinance/HELOC
          </td>
          <td>
            Charge for processing a customer's request for a home refinance/HELOC. (An additional $75 charge is added if a FNMA
            addendum is required.)
          </td>
          <td class="empty-row">&nbsp;</td>
          <td data-label="Pricing">&nbsp;$350</td>
        </tr>
        <tr>
          <td data-label="Service Charge">
            Refinance/HELOC Rush Charge
          </td>
          <td>
           A charge for a 2-3 business day turnaround.
          </td>
          <td class="empty-row">&nbsp;</td>
          <td data-label="Pricing">&nbsp;$50</td>
        </tr>
         <tr>
          <td data-label="Service Charge">
            Subordination
          </td>
          <td data-label="Description">
            Charge for processing a lender's request to subordinate Spruce Power's UCC filing or other recorded notice in connection with a customer refinance, HELOC, or similar financing transaction. Includes document preparation, coordination with the lender or title company, and submission of required materials. 
          </td>
          <td class="empty-row">&nbsp;</td>
          <td data-label="Pricing">
            $75
          </td>
        </tr>
        <tr>
          <td data-label="Service Charge">
            System Buyout Service Charge (Without Filing)
          </td>
          <td data-label="Description">
            Charge for processing a customer’s request for a system buyout
            associated with their solar system without filing.
          </td>
          <td class="empty-row">&nbsp;</td>
          <td data-label="Pricing">&nbsp;$300</td>
        </tr>
        <tr>
          <td data-label="Service Charge">
            System Buyout Service Charge (With Filing)
          </td>
          <td data-label="Description">
            Charge for processing a customer’s request for a system buyout
            associated with their solar system with filing.
          </td>
          <td class="empty-row">&nbsp;</td>
          <td data-label="Pricing">&nbsp;$400</td>
        </tr>
        <tr>
          <td data-label="Service Charge">
           Buyout Demand Rush Charge
          </td>
          <td data-label="Description">
            A fee would be charged for a 1-2 business day turnaround.
          </td>
          <td class="empty-row">&nbsp;</td>
          <td data-label="Pricing">&nbsp;$50</td>
        </tr>
        <tr>
          <td data-label="Service Charge">
            PUC Notice Filing Service Charge (CA only)
          </td>
          <td data-label="Description">
            Service charge for processing a customer’s request to file a CA PUC
            Notice. This service charge does not apply if a Home Filing Service
            Charge or Rush Service Charge applies to the same request.
          </td>
          <td class="empty-row">&nbsp;</td>
          <td data-label="Pricing">&nbsp;$200</td>
        </tr>
        <tr>
          <td data-label="Service Charge">Rush Service Charge (5-7 days)</td>
          <td data-label="Description">
            Expedited rush fee for processing a home filing request.
          </td>
          <td class="empty-row">&nbsp;</td>
          <td data-label="Pricing">&nbsp;$500</td>
        </tr>
        <tr>
          <td data-label="Service Charge">Rush Service Charge (2-4 days)</td>
          <td data-label="Description">
            Expedited rush fee for processing a home filing request.
          </td>
          <td class="empty-row">&nbsp;</td>
          <td data-label="Pricing">&nbsp;$1250</td>
        </tr>
        <tr>
          <td data-label="Service Charge">Rush Service Charge (Next day)</td>
          <td data-label="Description">
            Expedited rush fee for processing a home filing request.
          </td>
          <td class="empty-row">&nbsp;</td>
          <td data-label="Pricing">&nbsp;$1750</td>
        </tr>
        <tr>
          <td data-label="Service Charge">Title Report Pull Service Charge</td>
          <td data-label="Description">
            Processing fee for securing title for the customer solar system.
            Processing time is 10 business days.
          </td>
          <td class="empty-row">&nbsp;</td>
          <td data-label="Pricing">&nbsp;$1500</td>
        </tr>
        <tr>
          <td data-label="Service Charge">FNMA Addendum Service Charge</td>
          <td data-label="Description">
            Fee charged in response to customer requests to create a lender
            required addendum to the customer’s solar agreement that asserts
            lender’s rights in the event of a foreclosure.
          </td>
          <td class="empty-row">&nbsp;</td>
          <td data-label="Pricing">&nbsp;$100</td>
        </tr>
        <tr>
          <td data-label="Service Charge">FNMA Addendum Rush Charge</td>
          <td data-label="Description">
            A charge for same-day turnaround if received before 3 pm CST.
          </td>
          <td class="empty-row">&nbsp;</td>
          <td data-label="Pricing">&nbsp;$50</td>
        </tr>
        <tr>
          <td data-label="Service Charge">
            Customer Requested Truck-roll Service Charge
          </td>
          <td data-label="Description">
            Charge for a customer authorized truck roll after Spruce has already
            confirmed the system is properly operating and the customer still
            desires a truck roll.
          </td>
          <td class="empty-row">&nbsp;</td>
          <td data-label="Pricing">&nbsp;$375</td>
        </tr>
        <tr>
          <td data-label="Service Charge">Missed Appointment Service Charge</td>
          <td data-label="Description">
            Charge in the event a scheduled Service Call is executed and the
            homeowner is not available/home when the technician arrives, and a
            repeat service call is needed.
          </td>
          <td class="empty-row">&nbsp;</td>
          <td data-label="Pricing">&nbsp;$375</td>
        </tr>
        <tr>
          <td data-label="Service Charge">
            Temporary System Removal Processing Fee
          </td>
          <td data-label="Description">
            Covers administration, agreement processing, and tracking to ensure proper system reinstallation
          </td>
          <td class="empty-row">&nbsp;</td>
          <td data-label="Pricing">&nbsp;$165</td>
        </tr>
        <tr>
          <td data-label="Service Charge">
            Temporary System Removal
          </td>
          <td data-label="Description">
            Service Charge for Spruce Power to perform the temporary removal and reinstallation of rooftop solar components due to roof repairs or replacement.
            Pricing applies to all panels and railings for the rooftop system to ensure safety and system integrity. (NJ Only) <br/>
            *Additional charges may apply based on roof conditions or scope of work.
          </td>
          <td class="empty-row">&nbsp;</td>
          <td data-label="Pricing">&nbsp;$350 per panel*</td>
        </tr>
        <tr>
          <td data-label="Service Charge">
            3rd Party Battery Inspection Fee
          </td>
          <td data-label="Description">
            Post-installation inspection of battery installation to ensure that the solar system remains undamaged and fully
            operational.
          </td>
          <td class="empty-row">&nbsp;</td>
          <td data-label="Pricing">&nbsp;$400</td>
        </tr>
        <tr>
          <td data-label="Service Charge">
            Roof Leak Inspection Service Charge
          </td>
          <td data-label="Description">
            Charge when customer requests dispatch of a technician for a roof
            leak and the findings are that it is not solar related.
          </td>
          <td class="empty-row">&nbsp;</td>
          <td data-label="Pricing">&nbsp;$400</td>
        </tr>
        <tr>
          <td data-label="Service Charge">
            Non-Covered System Damage Repair
          </td>
          <td data-label="Description">
            Applies to repairs required due to damage caused by factors or conditions outside of Spruce Power’s control. Including but not limited to damage caused by wildlife, fire, severe weather impacts, or unauthorized modifications or work performed by third parties.
          </td>
          <td class="empty-row">&nbsp;</td>
          <td data-label="Pricing">&nbsp;Greater of $1,500 or actual cost</td>
        </tr>
        <tr>
          <td data-label="Service Charge">
            Monitoring Interruption Service Charge
          </td>
          <td data-label="Description">
            Charge for dispatch of a technician for a reported monitoring issue
            caused by customer action/inaction or other problems caused by
            customer’s network connection.
          </td>
          <td class="empty-row">&nbsp;</td>
          <td data-label="Pricing">&nbsp;$375</td>
        </tr>
        <tr>
          <td data-label="Service Charge">
            Disconnection Fee
          </td>
          <td data-label="Description">
            Charge to perform a system disconnection and provide notice of disconnection.
          </td>
          <td class="empty-row">&nbsp;</td>
          <td data-label="Pricing">&nbsp;$100</td>
        </tr>
        <tr>
          <td data-label="Service Charge">Reconnection Service Charge</td>
          <td data-label="Description">
            Charge for dispatch of a technician to reconnect solar system after
            disconnect due to non-payment.
          </td>
          <td class="empty-row">&nbsp;</td>
          <td data-label="Pricing">&nbsp;$375</td>
        </tr>
        <tr>
          <td data-label="Service Charge">
            Unaddressed Shading/Soiling Service Charge
          </td>
          <td data-label="Description">
            Charge for mitigation of shading/soiling (e.g. tree trimming,
            excessive bird droppings, excessive dust/dirt) and is not done as
            per customer’s contract and materially impacts solar system
            production (>10%).
          </td>
          <td class="empty-row">&nbsp;</td>
          <td data-label="Pricing">&nbsp;$375</td>
        </tr>
        <tr>
          <td data-label="Service Charge">
            Unresponsive Contact Service Charge
          </td>
          <td data-label="Description">
            Charge to a customer after customer is unresponsive to three (3)
            attempts to contact the customer via email, phone, or written
            notice.
          </td>
          <td class="empty-row">&nbsp;</td>
          <td data-label="Pricing">&nbsp;$25</td>
        </tr>
        <tr>
          <td data-label="Service Charge">Excess Debris Service Charge</td>
          <td data-label="Description">
            Charge to a customer for removal of debris, including animal
            infestation, which is impacting solar system production and is not
            addressed as per customer contract.
          </td>
          <td class="empty-row">&nbsp;</td>
          <td data-label="Pricing">Greater of $1,500 or actual cost</td>
        </tr>
        <tr>
          <td data-label="Service Charge">
            Asset Recovery & Processing Service Charge
          </td>
          <td data-label="Description">
            Charge to a customer for collection processing for outstanding
            balances >120 days.
          </td>
          <td class="empty-row">&nbsp;</td>
          <td data-label="Pricing">&nbsp;$125</td>
        </tr>
        <tr>
          <td data-label="Service Charge">
            Asset Recovery Legal Service Charge
          </td>
          <td data-label="Description">
            Charge to a customer for commencing legal review for outstanding
            balances >180 days.
          </td>
          <td class="empty-row">&nbsp;</td>
          <td data-label="Pricing">
            $200 plus 5% of outstanding balance at payoff
          </td>
        </tr>
        <tr>
          <td data-label="Service Charge">
            Breach Letter Mailing Charge
          </td>
          <td data-label="Description">
            Associated charge of distributing a breach letter
          </td>
          <td class="empty-row">&nbsp;</td>
          <td data-label="Pricing">
            $25
          </td>
        </tr>
        <tr>
          <td data-label="Service Charge">
            Physical Contract Charge
          </td>
          <td data-label="Description">
            Associated charge with distributing a physical paper contract.
          </td>
          <td class="empty-row">&nbsp;</td>
          <td data-label="Pricing">
            $15
          </td>
        </tr>
        <tr>
          <td data-label="Service Charge">
            Production Guarantee (PG) Recalculation
          </td>
          <td data-label="Description">
            A charge that covers the manual review and recalculation required outside of the standard workflow at the homeowner’s request.
          </td>
          <td class="empty-row">&nbsp;</td>
          <td data-label="Pricing">
            $50
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</section>

<app-footer></app-footer>
